

import {gql} from "apollo-angular";


const USER_NOTIFICATIONS = gql`
query NotificationsNode($receiver_Id: ID, $isDeleted: Boolean = false) {
  NotificationsNode(
    receiver_Id: $receiver_Id
    orderBy: "-id"
    isDeleted: $isDeleted
  ) {
    edges {
      node {
        id
        reference
        createdDate
        description
        isActive
        type {
          id
          name
        }
      }
    }
  }
}
`



const MARKNOTIFICATION_AS_READ = gql`
mutation featureMarknotificationAsRead($user: ID!) {
  featureMarknotificationAsRead(user: $user) {
    message
    success
  }
}
`


export {USER_NOTIFICATIONS, MARKNOTIFICATION_AS_READ}
